import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { SYSTEM_EVENTS_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const LOAD_SYSTEM_EVENTS = '_LOAD_SYSTEM_EVENTS';
export const DOWNLOAD_SYSTEM_EVENTS = '_DOWNLOAD_SYSTEM_EVENTS';

export const loadSystemEvents = createDeferredAction(SYSTEM_EVENTS_MODULE + LOAD_SYSTEM_EVENTS);
export const loadSystemEventsSuccessful = createAction(SYSTEM_EVENTS_MODULE + LOAD_SYSTEM_EVENTS + SUCCESSFUL);
export const loadSystemEventsFailed = createAction(SYSTEM_EVENTS_MODULE + LOAD_SYSTEM_EVENTS + FAILED);

export const downloadSystemEvents = createDeferredAction(SYSTEM_EVENTS_MODULE + DOWNLOAD_SYSTEM_EVENTS);
export const downloadSystemEventsSuccessful = createAction(SYSTEM_EVENTS_MODULE + DOWNLOAD_SYSTEM_EVENTS + SUCCESSFUL);
export const downloadSystemEventsFailed = createAction(SYSTEM_EVENTS_MODULE + DOWNLOAD_SYSTEM_EVENTS + FAILED);
